module.exports = __webpack_public_path__ + "static/media/mobile-service-game.4630871e.jpg";